import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {fadeInOut} from '../../../../../shared/animations/animations';
import {Select, Store} from '@ngxs/store';
import {take, withLatestFrom} from 'rxjs/operators';
import {ReportsState} from '../../../../../shared/states/reports/reports.state';
import {Observable} from 'rxjs/internal/Observable';
import {CreateNewDeaReport} from '../../../../../shared/states/reports/reports.actions';
import {REPORT_TIME_LIST, REPORT_TYPES_LIST} from '../../constants/constants';
import { ReportTimeTypeEnum } from 'src/app/shared/interfaces/ReportTimeTypeEnum';
import { PharmacyState } from 'src/app/shared/states/pharmacy/pharmacy.state';
import { DrugScheduleEnum } from 'src/app/shared/interfaces/DrugScheduleEnum ';

@Component({
  selector: 'app-run-report-dialog',
  templateUrl: './run-report-dialog.component.html',
  styleUrls: ['./run-report-dialog.component.scss'],
  animations: [fadeInOut],
})
export class RunReportDialogComponent {
  @Input() set show(value: boolean) {
    this.innerShow = value;

    if (value) {
      setTimeout(() => this.reportName?.appInput?.nativeElement.focus());
    }
  }

  get show(): boolean {
    return this.innerShow;
  }

  @Output() cancel: EventEmitter<void> = new EventEmitter();
  @Output() runReport: EventEmitter<string> = new EventEmitter();

  runReportForm: UntypedFormGroup;
  innerShow: boolean;

  reportTypesList = REPORT_TYPES_LIST;
  reportTimeList = REPORT_TIME_LIST;

  @ViewChild('reportName') reportName;
  @ViewChild('reportType') reportType;
  @ViewChild('reportTime') reportTime;

  @Select(ReportsState.loading) isLoading$: Observable<boolean | undefined>;
  @Select(ReportsState.newDeaReportId) newDeaReportId$: Observable<string>;
  @Select(PharmacyState.enableC3toC5Drugs) enableC3toC5Drugs$: Observable<boolean>;
  @Select(PharmacyState.inventoryLocationsEnabled) inventoryLocationsEnabled$: Observable<boolean>;

  constructor(
    private fb: UntypedFormBuilder,
    private store: Store,
  ) {
    this.runReportForm = this.fb.group({
      name: ['', []],
      reportType: [REPORT_TYPES_LIST[0].id, []],
      reportTime: [ReportTimeTypeEnum.StartOfDay, []],
      schedules: [[{id: DrugScheduleEnum.C2, name: 'Schedule II', badgeAlias: 'CII'}]],
      inventoryLocations: []
    });
  }

  createReport(): void {
    const raw = this.runReportForm.getRawValue();
    const selectedReportType = REPORT_TYPES_LIST.find(t => t.id === raw.reportType);
    this.store.dispatch(new CreateNewDeaReport(
      raw.reportTime, selectedReportType.id === 1, raw.name, this.store.selectSnapshot(PharmacyState.enableC3toC5Drugs), raw?.schedules?.map(x => x.id), 
      raw?.inventoryLocations?.map(x => x.id))
    )
      .pipe(take(1), withLatestFrom(this.newDeaReportId$))
      .subscribe(([_, id]) => {
        // TODO: validate success and error of new report
        if (id) {
          this.runReport.emit(id);
          this.close();
        }
      });
  }

  focusRadioGroup(radioListName: string): void {
    // console.log(this[radioListName]);
  }

  close(): void {
    this.runReportForm.patchValue({
      name: '',
      reportType: REPORT_TYPES_LIST[0].id,
      reportTime: ReportTimeTypeEnum.StartOfDay,
    });

    this.cancel.emit();
  }
}
